import React from "react";
import PropTypes from "prop-types";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import classNames from "classnames";
import useCountryData from "@/modules/shared/hooks/use-country-data";

/**
 * CountrySelect — Syncfusion DropDownList pre-wired to the countries Redux store.
 *
 * Emits the **full item** `{ value, label, isoCode }` via `onChange` so
 * callers can access the ISO code without a secondary lookup.
 */
export default function CountrySelect({
  placeholder = "Country",
  value,
  onChange,
  error,
  disabled = false,
  className,
  floatLabelType = "Auto",
  ...props
}) {
  const { dataSource, handleChange, defaultValue, itemTemplate } = useCountryData({ onChange });

  return (
    <div className={classNames("select-input-wrapper", className)}>
      <DropDownListComponent
        key={dataSource.length > 0 ? "ready" : "loading"}
        placeholder={placeholder}
        floatLabelType={floatLabelType}
        dataSource={dataSource}
        fields={{ text: "text", value: "value" }}
        value={value ?? defaultValue}
        change={handleChange}
        enabled={!disabled && dataSource.length > 0}
        cssClass={classNames("e-outline", { "e-error": !!error })}
        itemTemplate={itemTemplate}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}

CountrySelect.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  floatLabelType: PropTypes.oneOf(["Auto", "Always", "Never"]),
};

